import CustomSVGs from '../../../ui/customSVGs/CustomSVGs';
import { plusSignSVG } from '../../../lib/allCustomSVGs';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  setCurrentChat,
  setIsBotTyping,
  setPreviousResponseId,
} from '../../../store/reducers/chatSlice';
import { RootState } from '../../../store/store';
import taraChatAnimationEngine from '../../../lib/helper-functions/taraChatAnimationEngine';
import '../../../styles/pages/tara/history/taraCreateNewChat.scss';

interface Props {
  isSidebarMinimized: boolean;
}

const TaraCreateNewChat = ({ isSidebarMinimized }: Props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isSidebarMinimizedState = useSelector(
    (state: RootState) => state.UI.isSidebarMinimized
  );

  const createNewChat = () => {
    navigate('/tara');
    dispatch(setCurrentChat(null));
    dispatch(setIsBotTyping(false));
    dispatch(setPreviousResponseId(null));

    // Reset header to normal visible state when initiating a new chat
    taraChatAnimationEngine('initial', isSidebarMinimizedState);
  };

  return (
    <div
      className='taraCreateNewChat'
      data-is-sidebar-minimized-new-chat={isSidebarMinimized.toString()}
    >
      <div onClick={createNewChat} className='taraCreateNewChat__content'>
        <CustomSVGs svg={plusSignSVG} />
        <div>{t('NewChat')}</div>
      </div>
    </div>
  );
};

export default TaraCreateNewChat;
